var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"submit-request"},[_c('h1',{staticClass:"fn-title-1"},[_vm._v("Заявка на кредит")]),_c('CreditFormNew')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }